<template>
  <el-pagination
    :pager-count="5"
    :page-sizes="[5, 10, 30]"
    :current-page="page"
    :page-size="pageSize"
    style="text-align: center; margin-top: 10px"
    @current-change="handleCurrentChange"
    @size-change="handleSizeChange"
    :layout="layout"
    :total="total"
  >
  </el-pagination>
</template>
<script>
export default {
  methods: {
    handleCurrentChange(val) {
      let params = this.getQuery();
      params.page = val;
      this.$router.replace({ query: params });
    },
    handleSizeChange(val) {
      let params = this.getQuery();
      params.pageSize = val;
      this.$router.replace({ query: params });
    },
    getQuery() {
      return Object.assign({}, this.$route.query);
    },
  },
  props: {
    defaultPage: { type: Number, required: true },
    defaultPageSize: { type: Number, required: true },
    total: { type: Number, required: true },
  },
  computed: {
    page: function () {
      if (this.$route.query.page) {
        return parseInt(this.$route.query.page);
      } else {
        return this.defaultPage;
      }
    },
    pageSize: function () {
      if (this.$route.query.pageSize) {
        return parseInt(this.$route.query.pageSize);
      } else {
        return this.defaultPageSize;
      }
    },
    layout: function () {
      if (this.isMobile()) {
        return "prev,pager,next";
      } else {
        return "total,sizes,prev,pager,next,jumper";
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Pagination.vue?6aa9e98e